var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataList',{attrs:{"dataList":_vm.fileList,"showType":"TextList","totalCount":_vm.count,"hasPagination":true},on:{"handlePageChange":_vm.handlePageChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }